module.exports = __webpack_public_path__ + "images/daihatsu_small48adf29d4715e2bee15ba09903371473.png";